module.exports = __webpack_public_path__ + "static/media/team-bruce.fb929077.jpg";